
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scuola-primaria/risorse",
      function () {
        return require("private-next-pages/scuola-primaria/risorse.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scuola-primaria/risorse"])
      });
    }
  